import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=7d443c2f&scoped=true&"
import script from "./Posts.vue?vue&type=script&lang=js&"
export * from "./Posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d443c2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d443c2f')) {
      api.createRecord('7d443c2f', component.options)
    } else {
      api.reload('7d443c2f', component.options)
    }
    module.hot.accept("./Posts.vue?vue&type=template&id=7d443c2f&scoped=true&", function () {
      api.rerender('7d443c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Post/Posts.vue"
export default component.exports